const initialState = {
    anchor: 'left',
    termoUso: [],
    open: false,
    id: '',
    versao: 0,
    link: '',
    sistema: '',
    conteudo_arquivo: '',
    data_cadastro: '',
    usuario_cadastro: '',
    data_exclusao: '',
    usuario_exclusao: ''
};

export function termoUso(state = initialState, action) {
    switch (action.type) {
        case 'FETECHED_ALL_TERMO_USO':
            return {
                ...state,
                termoUso: action.termoUso
            };
        case 'TERMO_USO_DETAIL':
            return {
                ...state,
                id: action.id,
                termoUso: action.termoUso,
                versao: action.versao,
                link: action.link,
                sistema: action.sistema,
                conteudo_arquivo: action.conteudo_arquivo,
                data_cadastro: action.data_cadastro,
                usuario_cadastro: action.usuario_cadastro,
                data_exclusao: action.data_exclusao,
                usuario_exclusao: action.usuario_exclusao
            };
        case 'TERMO_USO_CLEAR':
            return {
                ...state,
                anchor: 'left',
                termoUso: [],
                open: false,
                id: '',
                versao: 0,
                data_cadastro: '',
                usuario_cadastro: '',
                data_exclusao: '',
                usuario_exclusao: '',
                link: '',
                sistema: '',
                conteudo_arquivo: ''
            };
        case "TERMO_USO_UPDATED":
            return state;
        case "HANDLE_ON_CHANGE":
            return {
                ...state,
                [action.props]: action.value
            };
        default:
            return state
    }
}
